import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ShiftAssignment } from "src/app/models/HR/ShiftAssignment/shiftAssignment.model";
import { IShiftAssignmentRepository } from "./IShiftAssignmentRepository";

@Injectable({
  providedIn: 'root'
})
export class ShiftAssignmentRepository
    extends GenericRepository<ShiftAssignment>
    implements IShiftAssignmentRepository {

    constructor(protected _http: HttpClient) {
        super(_http, 'api/shiftAssignment', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string, completed: number): Observable<any> {
        filterText = filterText ? encodeURIComponent(filterText.split('/').join('~')) : '|';
        return this.Get(`SelectAll/${currentPage}/${recordsPerPage}/${filterText}/${completed}`);
    }

    SelectAllByEmployee(employeeId: number, currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText ? encodeURIComponent(filterText.split('/').join('~')) : '|';
        return this.Get(`SelectAllByEmployee/${employeeId}/${currentPage}/${recordsPerPage}/${filterText}`);
    }

    SaveRec(item: ShiftAssignment): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }
    

    LoadRec(id: number): Observable<ResponseModel> {
        return this.GetById(`GetRec/${id}`).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }

    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById(`NavRec/${navType}/${currentIndex}`).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }

    DeleteRec(id: number): Observable<ResponseModel> {
        return this.Delete(`DeleteRec/${id}`).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }

    Search(name: string): Observable<ResponseModel> {
        const encodedName = encodeURIComponent(name);
        return this.GetById(`Search/${encodedName}`).pipe(
            map(this.extractData),
            catchError(this.handleError)
        );
    }
}